import * as React from "react";

const Card = ({ title, imageSrc, redirectTo, style, imageSize }) => {
  return (
    <div className="flex flex-col grow justify-center items-center w-full text-3xl font-semibold text-black uppercase bg-white rounded-lg shadow-lg leading-[50px] max-md:max-w-full" style={{ ...style }}>
      <a target="_blank" href={redirectTo} >
        <img
          src={imageSrc}
          alt={title}
          className={`max-w-full ${imageSize}`}
        />
      </a>
    </div>
  );
};

const Content = () => {
  const cardData = [
    {
      name: "World Trade Centers Association",
      imageSrc: "/assets/images/membership/membership-1.png",
      website: "https://wtca.org/",
      style: {
        background: '#434343',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[100px] w-full"
    },
    {
      name: "The Institute of Indian Foundrymen",
      imageSrc: "/assets/images/membership/membership-2.png",
      website: "https://iif.in/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[100px] w-full"
    },
    {
      name: "Indo-German Chamber of Commerce (AHK)",
      imageSrc: "/assets/images/membership/membership-3.png",
      website: "https://indien.ahk.de/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[80px] w-full"
    },
    {
      name: "Mahratta Chamber of Commerce, Industries and Agriculture (MCCIA)",
      imageSrc: "/assets/images/membership/membership-4.png",
      website: "https://mcciapune.com/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[70px] w-full"
    },
    {
      name: "Ranjangaon Industries Association",
      imageSrc: "/assets/images/membership/membership-5.png",
      website: "https://ranjangaonia.org/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[100px] w-full"
    },
    {
      name: "Indo-American Chamber of Commerce (IACC)",
      imageSrc: "/assets/images/membership/membership-6.png",
      website: "https://iaccindia.com/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[100px] w-full"
    },
    {
      name: "Confederation of Indian Industry (CII)",
      imageSrc: "/assets/images/membership/membership-7.png",
      website: "https://cii.in/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
        padding: '0.5rem',
      },
      imageSize: "h-[140px] w-full"
    },
    {
      name: "Institute of Indian Interior Designers (IIID)",
      imageSrc: "/assets/images/membership/membership-8.png",
      website: "https://iiid.net.in/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[70px] w-full"
    },
    {
      name: "IFRS Sustainability Alliance",
      imageSrc: "/assets/images/membership/membership-9.png",
      website: "https://www.ifrs.org/groups/ifrs-sustainability-alliance/",
      style: {
        background: '#FFF',
        aspectRatio: "5.26/2",
      },
      imageSize: "h-[80px] w-full"
    }
  ]


  return (
    <section className="w-full mt-2 max-md:max-w-full">
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
        <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-3 ">
          {cardData.map(card => <Card {...card} />)}
        </div>
      </div>
    </section>
  );
};

export default Content;
